// eslint-disable-next-line import/no-unresolved
// import '@less/reset.less';
import Vue from 'vue';
import animated from 'animate.css';
import VueFullPage from 'vue-fullpage.js';

import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/ant-design-vue';

Vue.use(VueFullPage);
Vue.use(animated);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
